import { useUiStore } from '@/stores/UiStore'
import ContextMenuItem from '../ContextMenuItem'
import { UPDATE_TRUCK_LOCATION } from '@/constants/dispatch'

/**
 * SetTruckLocation context menu item.
 *
 * @author Alejandro Sanchez <asanchez@boltsystem.com>
 */
export default class SetTruckLocation extends ContextMenuItem {
    /**
     * Get the action callback function.
     *
     * @return {Function}
     */
    action() {
        return () => {
            const uiStore = useUiStore()

            const id = this.params.node.data.id

            if (id) {
                uiStore.openAction(UPDATE_TRUCK_LOCATION, { id })
            }
        }
    }

    /**
     * Determine if the menu item should be enabled/disabled.
     *
     * @return {Boolean}
     */
    disabled() {
        const IN_TRANSIT = 'INTRANSIT'
        const data = this.params?.node?.data

        if (!data) {
            return true
        }

        const truck = data?.truck
        const carrier = data?.carrier
        const status = data?.status?.code
        const isTruckAndCarrierEmpty = !truck?.id && !carrier
        const selectedRows = this.params?.api?.getSelectedRows() || []

        return (
            selectedRows.length > 1 ||
            status !== IN_TRANSIT ||
            isTruckAndCarrierEmpty
        )
    }

    /**
     * The name of the menu item to display.
     *
     * @return {String}
     */
    name() {
        return 'Set Truck Location'
    }

    /**
     * The tooltip to display on hover.
     *
     * @return {String?}
     */
    tooltip() {
        return 'Click to change the truck of this column based on the selected value'
    }
}
